import React, { useMemo } from 'react';
import { Image, ImageBackground, View } from 'react-native';
import Button from '../Button';
import Text from '../Text';
import INSURANCES from '~/utils/insurance';
import type { InsuranceType } from '~/@types/insurance';
import { isWeb } from '~/utils/device';

interface Props {
  type: InsuranceType;
  onHire?: () => void;
}

const Banner: React.FC<Props> = ({ type, onHire }) => {
  const config = useMemo(() => {
    return INSURANCES.find((i) => i.type === type);
  }, [type]);

  return (
    <>
      <ImageBackground
        source={config?.banner.mobile || {}}
        resizeMode="cover"
        className={`w-full xl:hidden ${
          onHire ? 'h-48' : 'h-40'
        } justify-center xl:rounded-2xl xl:mt-24 flex xl:hidden`}
      >
        <View className={`pl-6 w-[55%]`}>
          <Text className="text-light-100 text-lg font-bold">
            {config?.name}
          </Text>

          <Text className="text-light-100 mt-2 text-sm w-full">
            {config?.description}
          </Text>

          {!!onHire && (
            <Button
              className="mr-auto px-4 py-2 rounded-2xl mt-4"
              onPress={onHire}
            >
              CONTRATE
            </Button>
          )}
        </View>
        <Text
          className={`pl-6 text-light-100 mt-4 ${
            isWeb ? 'text-xs' : 'text-[8px]'
          }`}
        >
          {config?.additionalText}
        </Text>
      </ImageBackground>

      <Image
        source={config?.banner.web || {}}
        resizeMode="cover"
        className={`w-[518px] h-[669px] p-6 hidden xl:flex rounded-2xl`}
      />
    </>
  );
};

export default Banner;
